import { Button } from 'components/common'
import SearchBar from 'components/common/dataTable/searchBar'
import { PlusIcon } from 'components/icons'
import { StoreTable } from 'components/storeManagement'
import { usePageAccess } from 'hooks'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import { PAGE_ADD_STORE } from 'utils/constants'

const StoreManagement = () => {
  const navigate = useNavigate()

  const { isEditor } = usePageAccess()

  return (
    <>
      <Helmet>
        <title>ORMS Store Management</title>
      </Helmet>

      {/* Create Store Button */}
      {isEditor && (
        <Button
          buttonText="Create New Store"
          icon={<PlusIcon />}
          className="mb-5"
          onClick={() => navigate(PAGE_ADD_STORE.path)}
        />
      )}

      <div
        className={`${
          isEditor ? 'mt-4' : ''
        } mb-2 flex flex-wrap items-center justify-between  md:mb-0 md:flex-nowrap`}
      >
        <h3 className="title">Current Stores</h3>
        <SearchBar placeholder="Search by Store Name and ID" />
      </div>

      {/* Store List */}
      <StoreTable isEditor={isEditor} />
    </>
  )
}

export default StoreManagement
